import { Component, Input } from '@angular/core'
import { EluxIcon } from '@elxjs/ui'
import { ToastService } from '@common'

@Component({
  selector: 'app-copy-url-button',
  standalone: true,
  imports: [EluxIcon],
  templateUrl: './copy-url-button.component.html',
  styleUrls: ['./copy-url-button.component.scss'],
})
export class CopyUrlButtonComponent {
  @Input() prefix: string = ''
  @Input() slug: string | null = ''
  @Input() disabled: boolean = false

  constructor(private toastService: ToastService) {}

  get isDisabled(): boolean {
    return this.disabled || !String(this.slug ?? '').trim()
  }

  async copy(): Promise<void> {
    if (this.isDisabled) return

    const url = this.prefix + String(this.slug ?? '').trim()

    try {
      await navigator.clipboard.writeText(url)
      this.toastService.success('URL copiada.')
    } catch {
      this.toastService.error('Não foi possível copiar a URL.')
    }
  }
}
